import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

if (typeof window !== "undefined") {
  const capacitor = (window as any).Capacitor;
  const isNative =
    typeof capacitor?.isNativePlatform === "function"
      ? capacitor.isNativePlatform()
      : false;

  if (isNative) {
    const splashScreen = capacitor?.Plugins?.SplashScreen;
    if (typeof splashScreen?.hide === "function") {
      void Promise.resolve(splashScreen.hide()).catch(() => undefined);
    }
  }
}
